import { firebaseFunctionsService } from "@infrastructure/firebase/firebaseFunctionsService";

export type SafetyHelpLocation = {
  latitude: number;
  longitude: number;
  accuracy?: number;
  capturedAt?: string;
};

export type RequestSafetyHelpInput = {
  message?: string | null;
  location?: SafetyHelpLocation | null;
};

export type RequestSafetyHelpResult = {
  alertId: string;
  usedFallback: boolean;
  recipientCount: number;
};

export async function requestSafetyHelp(input: RequestSafetyHelpInput): Promise<RequestSafetyHelpResult> {
  const result = await firebaseFunctionsService.callFunctionWithData("requestSafetyHelp", {
    message: input.message ?? null,
    location: input.location ?? null,
  });
  return result.data as RequestSafetyHelpResult;
}
